// Function that works in tandem with a state variable to fade in the page
// Use in the outtermost container that wraps the entire page
export const LoadInFade = (loaded) => ({
  opacity: loaded ? 1 : 0,
  transition: "opacity 0.5s ease-in-out",
});

export default LoadInFade;
